$(document).ready(function() {

	$('.order-set-all-paid-butt').on( 'click', function() {

		let subscriptions_ar = [];

		document.querySelectorAll('.order-summary-table > tbody > tr').forEach( $tr => {
			if ( typeof $tr.dataset.id_subscription != "undefined")
				subscriptions_ar.push($tr.dataset.id_subscription);
		});

		swal({
			title: set_all_paid_dialog.dialog_text,
			buttons: {
				cancel: {
					text: set_all_paid_dialog.cancel_butt,
					value: false,
					visible: true,
					className: "",
					closeModal: true
				},
				setallpaid: {
					text: set_all_paid_dialog.confirm_butt,
					value: true,
					visible: true,
					className: "",
					closeModal: true
				}
			},
			icon: "warning"
		}).then(function(isConfirm) {
			if (isConfirm != null)

				$.post(
					APP_ROOT +
						"/api/" +
						LOCALE +
						"/v1/race-manager/subscription/set-payment-status",
					{
						paid: 1,
						id_subscription_ar: subscriptions_ar
					},
					function(response) {
						// Subscriptions belonging to orders paid online are not modified by the server
						let skipped_subscriptions = response.skipped_subscriptions || [];

						document.querySelectorAll('.order-summary-table > tbody > tr').forEach( $tr => {
							if ( typeof $tr.dataset.id_subscription != "undefined") {
								if (skipped_subscriptions.some( skipped_id => skipped_id == $tr.dataset.id_subscription )) return;

								let $td = $tr.querySelector('td.set-paid-butt.paid-column');
								if ($td) {
									$td.classList.add('paid');
									let $span = $td.querySelector('span');
									if ($span) $span.textContent = '1';
								}
							}
						});

						if (skipped_subscriptions.length) {
							swal({
								title: set_all_paid_dialog.skipped_title,
								text: set_all_paid_dialog.skipped_text,
								icon: "warning"
							})
						} else {
							swal({
								title: set_all_paid_dialog.confirm_text,
								icon: "success"
							})
						}
					},
					"json"
				);

		});

	})

})
